<template>
  <div class="container flex">
    <!-- <nav-header v-if="topType" ref="componenta" @getList="getList"></nav-header> -->
	<div class="denglu">
		<nav-footer v-if="topType" ref="dingbu" @qiehuan="yuyan"></nav-footer>
		<router-view ref="routerView" class="yangshi" :parentPrint="parentPrint" ></router-view>
	</div>
    
  </div>
</template>

<script>
  const { default: NavFooter }=require("@/components/NavFooter.vue")
  const { default: NavHeader }=require("@/components/NavHeader.vue")

  export default {
    components: { NavFooter, NavHeader },
	data() {
		return {
			topType:true
		}
	},
	    watch: {
	        //监听路由地址的改变
	        $route:{
	            immediate:true,
	            handler(){
		            // console.log(this.$route.path,'路由变化')
					if(this.$route.path == '/index'){
						if(this.$refs.componenta){
							this.$refs.componenta.type = 0
						}
					}
					if(this.$route.path == '/login'){
						this.topType = false
					}else{
						this.topType = true
					}
	            }
	        }
	    },
	methods:{
		// 语言切换
		yuyan(){
			console.log(1111111111111)
			this.$refs.routerView.gengxin()
		},
		
		parentPrint(){
			this.$refs.componenta.xinxi();
		},
		getList(name) {
		  this.$refs.dingbu.testA(name);
		  // console.log(name,123)
		  
		},
	}
  }
  
</script>

<style >
	.align-items{
		align-items: center;
	}
	
	.yangshi{
		/* background: #F5F6F7 !important; */
		/* border-top: 20px solid #F5F6F7;
		border-left: 20px solid #F5F6F7; */
		/* padding: 20px; */
		/* box-sizing: border-box; */
		width: 100%;
		/* height: 100%; */
		/* background: #fff; */
	}
	.denglu{
		width: 100%;
	}
	.bixuan:before{
		    content: "*";
		    color: #f56c6c;
		    margin-right: 4px;
	}
	body,
	html{
		padding: 0 !important;
		margin: 0 !important;
		background: #F8F8FA !important;
	}
	.w1600{
		width:1600px;
		margin: 0 auto;
	}
	.w1200{
		width:1200px;
		margin: 0 auto;
	}
	.kandu{
		width: calc(100% - 250px)
	}
	.absolute{
		position: absolute;
	}
	.relative{
		position: relative;
	}
	.fixed{
		position: fixed;
	}
	.p1{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}
	.p2{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	.p3{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}
	.flex{
		display: flex;
		
	}
	.justify-content{
		justify-content: center;
	}
	.align-content{
		align-content: center;
	}
	.align-end {
	    align-items: flex-end;
	}
	.flex-sub {
	    flex: 1;
	}
	.wrap{
		flex-wrap: wrap;
	}
	.space-between{
		justify-content:space-between;
	}
	.flex-end{
		justify-content:flex-end;
	}
	.pointer{
		cursor:pointer
	}
    .container {
		/* background: #F5F6F7 !important; */
		/* background: #F8F8FA;
		min-height: calc(100vh - 150px); */
    }
	.bodycolor{
		color: #0DC3D6 !important;
	}
	.borderBottm{
		border-bottom: 1px dashed  #0DC3D6 !important;
	}
	.justify-content{
		justify-content: center;
	}
	img{
		width: 100%;
	}
	.scroll-box::-webkit-scrollbar {
	    display: none !important;
	  }
	.benben-flex-layout {
	    display: flex;
	}
	
	::v-deep .el-loading-mask {
		opacity: 1 !important; 
		  background-color: rgba(255, 255, 255, 1) !important;
	}
::-webkit-scrollbar {
  background: transparent;
  width: 0px;
  height: 10px
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background-color: #e1e1e1;
  width: 0px;
  height: 6px;
  border: 2px solid transparent;
  background-clip: content-box
}

</style>

